export default {
  All: {
    continent: {
      ko: 'ALL',
      ja: '全体',
      en: 'ALL'
    },
    country: {
      ALL: ''
    }
  },
  Korea: {
    continent: {
      ko: '한국총괄(SEC)',
      ja: '韓国総括(SEC)',
      en: 'SEC'
    },
    country: {
      SEC: 'Korean'
    }
  },
  NorthAmerica: {
    continent: {
      ko: '북미',
      ja: '北米',
      en: 'North America'
    },
    country: {
      CA: 'English',
      CA_FR: 'French',
      US: 'English'
    }
  },
  LHQ: {
    continent: {
      ko: '중남미(LHQ)',
      ja: '中南米(LHQ)',
      en: 'Latin America(LHQ)'
    },
    country: {
      AR: 'Spanish',
      BR: 'Portuquese',
      CL: 'Spanish',
      CO: 'Spanish',
      LATIN: 'Spanish',
      LATIN_EN: 'English',
      MX: 'Spanish',
      PE: 'Spanish',
      PY: 'Spanish',
      UY: 'Spanish'
    }
  },
  SEA: {
    continent: {
      ko: '동남아(SEA HQ)',
      ja: '東南アジア(SEA HQ)',
      en: 'Southeast Asia(SEA HQ)'
    },
    country: {
      AU: 'English',
      ID: 'Indonesian',
      MM: 'Burmese',
      MY: 'English',
      NZ: 'English',
      PH: 'English',
      SG: 'English',
      TH: 'Thai',
      VN: 'Vietnameses'
    }
  },
  Japan: {
    continent: {
      ko: '일본',
      ja: '日本',
      en: 'Japan'
    },
    country: {
      JP: 'Japanese'
    }
  },
  SWA: {
    continent: {
      ko: '서남아(SWA HQ)',
      ja: '西南アジア(SWA HQ)',
      en: 'Southwest Asia(SWA HQ)'
    },
    country: {
      IN: 'English',
      BD: 'English'
    }
  },
  EHQ: {
    continent: {
      ko: 'EHQ',
      ja: 'EHQ',
      en: 'EHQ'
    },
    country: {
      AL: 'Albanian',
      AT: 'German',
      BE: 'Dutch',
      BE_FR: 'French',
      BG: 'Bulgarian',
      CH: 'German',
      CH_FR: 'French',
      CZ: 'Czech',
      DE: 'German',
      DK: 'Danish',
      EE: 'Estonian',
      ES: 'Spanish',
      FI: 'Finnish',
      FR: 'French',
      GR: 'Greek',
      HR: 'Croatian',
      HU: 'Hungaian',
      IE: 'English',
      IT: 'Italian',
      LT: 'Lithuanian',
      LV: 'Latvian',
      NL: 'Dutch',
      NO: 'Norwegian',
      PL: 'Polish',
      PT: 'Portuquese',
      RO: 'Romanian',
      RS: 'Serbian',
      SE: 'Swedish',
      SI: 'Slovenian',
      SK: 'Slovakian',
      UK: 'English',
      AZ: 'Azerbaijiani',
      BA: 'Bosnian',
      MK: 'Macedonian'
    }
  },
  CIS: {
    continent: {
      ko: 'CIS(CIS HQ)',
      ja: 'CIS(CIS HQ)',
      en: 'CIS(CIS HQ)'
    },
    country: {
      KZ_RU: 'Russian',
      RU: 'Russian',
      UA: 'Ukranian',
      KZ_KZ: 'Kazakh',
      UZ_RU: 'Russian',
      UZ_UZ: 'Uzbek'
    }
  },
  MENA: {
    continent: {
      ko: '중동, 북아프리카(MENA HQ)',
      ja: '中東、北アフリカ(MENA HQ)',
      en: 'Middle East and North Africa(MENA HQ)'
    },
    country: {
      AE: 'English',
      AE_AR: 'Arabic',
      EG: 'Arabic',
      IL: 'Hebrew',
      IRAN: 'Persian',
      LB: 'English',
      LEVANT: 'English',
      N_AFRICA: 'French',
      PK: 'English',
      SA: 'Arabic',
      SA_EN: 'English',
      TR: 'Turkish',
      LEVANT_AR: 'Arabic',
      PS: 'Arabic'
    }
  },
  Africa: {
    continent: {
      ko: '아프리카',
      ja: 'アフリカ',
      en: 'Africa HQ'
    },
    country: {
      AFRICA_EN: 'English',
      AFRICA_FR: 'French',
      AFRICA_PT: 'Portuguese',
      ZA: 'English'
    }
  },
  China: {
    continent: {
      ko: '중국',
      ja: '中国',
      en: 'China'
    },
    country: {
      CN: 'Chinese simplified',
      HK: 'Chinese Traditional',
      HK_EN: 'English',
      TW: 'Chinese Traditional'
    }
  }
}
